import './DeletAssistant.css';
import { useTranslation } from 'react-i18next'; // Importa o hook de tradução

function ConfirmDeleteModal2({ isOpen, onClose, onConfirm, title, message, confirmLabel, cancelLabel }) {
  const { t: tCommon } = useTranslation('common');
  
  if (!isOpen) return null; 

  const modalTitle = title || tCommon('confirm_delet');
  const modalMessage = message || '';

  return (
    <div className="modal-overlay">
      <div className="modal-content-delete">
        <img src="/imagens/trash-red.svg" alt={tCommon("trashIcon")} className="modal-icon" />
        <p className="modal-message">{modalTitle}</p>
        {modalMessage && <p className="modal-submessage">{modalMessage}</p>}
        <div className="modal-actions">
          <button className="modal-button confirm" onClick={onConfirm}>{tCommon('yes')}</button>
          <button className="modal-button cancel" onClick={onClose}>{tCommon('no')}</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDeleteModal2;
